import React from 'react';
import { BasicTable } from '../shared/BasicTable/BasicTable';
import { InvoiceDetailsDialogTitle } from '../shared/Typography/InvoiceDetailsDialogTitle';
import { useTranslation } from 'react-i18next';
import { ShipmentLabelDetailsTableRow } from './ShipmentLabelDetailsTableRow';
import Paper from '@mui/material/Paper';
import { TableContainer } from '@mui/material';
import { ShipmentsData } from 'models/Shipments';
import { SHIPMENT_LABEL_DETAILS_HEAD_CELLS } from 'utils/constans/tableHeads/shipmentsTableHead';

const InvoiceDetails: React.FC<{ shipmentLabel: ShipmentsData }> = (props) => {
    const rows = [props.shipmentLabel];
    const { t } = useTranslation('shipments', {
        keyPrefix: 'SHIPMENT_DETAILS',
    });

    const tableHeadSettings = {
        translateNs: 'shipments',
        translatePrefix: 'SHIPMENTS.TABLE_HEAD',
        selectable: false,
        headContent: SHIPMENT_LABEL_DETAILS_HEAD_CELLS,
    };

    return (
        <>
            <InvoiceDetailsDialogTitle>
                {t('DETAILS_TITLE')}
            </InvoiceDetailsDialogTitle>
            <TableContainer component={Paper}>
                <BasicTable<ShipmentsData, ShipmentsData>
                    fullList={rows}
                    tableHeadSettings={tableHeadSettings}
                    component={ShipmentLabelDetailsTableRow}
                />
            </TableContainer>
        </>
    );
};

export default InvoiceDetails;
